<template lang="html">
  <div class="ratioContainer" :style="containerStyle">
    <picture>
      <!--[if IE 9]><video style="display: none;><![endif]-->   
        <source
          type="image/webp"
          :data-srcset="
            widths.map(w =>  (
              imageUrl
                .image(source)
                .width(w)
                .height(parseInt(w / ratio, 10))
                .fit(fit || 'crop')
                .format('webp')
                .quality(80)
                .url() + ` ${w}w`
            )).join(', ')"          
        />
        <source
          :data-srcset="
            widths.map(w =>  (
              imageUrl
                .image(source)
                .width(w)
                .height(parseInt(w / ratio, 10))
                .fit(fit || 'crop')
                .format(transparent ? 'png' : 'jpg')
                .quality(80)
                .url() + ` ${w}w`
            )).join(', ')"          
        />        

        <img 
          data-parent-fit="contain"
          :src="lqip" 
          class="lazyload blurUp"
          data-sizes="auto"          
          :alt="alt"
          ref="imageEl"
        >
      <!--[if IE 9]></video><![endif]-->
    </picture>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'image-source',
  data () {
    return {
      srcset: null,
      styles: '',
      widths: [500, 1000, 1500, 2000]
    }
  },
  props: ['source', 'ratio', 'alt', 'params', 'metadata', 'width', 'fit', 'chapterUrlBuilder', 'transparent'],
  watch: {
    // Watch for changes in source of component and update if so
    // A fix to make chapter leader images update on navigation
    'source': function () {
      window.lazySizes.loader.unveil(this.$refs.imageEl)
    }
  },
  computed: {
    containerStyle: function () {
      return {
        // We can't access this variable in the :after pseudo element
        'paddingBottom': (1 / this.ratio) * 100 + '%',
        'backgroundImage': !this.transparent && `url(${this.imageUrl
          .image(this.source)
          .width(100)
          .height(parseInt(100 / this.ratio))
          .blur(80)
          .url()})`
      }
    },
    imageUrl () {
      return this.chapterUrlBuilder
        ? this.$chapterSanityUrl
        : this.$sanityImageUrl
    },
    lqip: function () {
      // Fall back to tiny image if no base64 LQIP is provided from Sanity
      const lqip = get(this.source, 'asset.metadata.lqip')
      const fit = this.fit || 'crop'

      return lqip || this.imageUrl
        .image(this.source)
        .width(100)
        .height(parseInt((100 * this.ratio), 10))
        .fit(fit)
        .format(this.transparent ? 'png' : 'jpg')
        .quality(80)
        .url()
    }
  }
}
</script>

<style lang="css">
  .ratioContainer {
    position: relative;
    height: 0;
    display: block;
    width: 100%;
    background-size: cover;
  }

  .ratioContainer img,
  .ratioContainer iframe,
  .ratioContainer video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;  
    opacity: 0;
    transition: opacity 0.3s cubic-bezier(.25,.46,.45,.94);    
  }

  .ratioContainer .lazyloaded {
    opacity: 1;

  }

  .is-transparent .ratioContainer {
    background-color: transparent !important;
  }
/*
  .ratioContainer {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .ratioContainer:after {
      content: '';
      display: block;
      height: 0;
      width: 100%;
      padding-bottom: var(--ratio);
  }

  .ratioContainer > * {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      color: transparent;
  }

*/
  /* .blur-up {
    -webkit-filter: blur(5px);
    filter: blur(5px);
    transition: filter 400ms, -webkit-filter 400ms;
  }

.blur-up.lazyloaded {
  -webkit-filter: blur(0);
  filter: blur(0);
} */
picture, picture img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageSource.vue